import { useState } from 'react';
// Haltungsprotokoll header (DIN EN 13508-2 style) stored on the pipe as p.hk
export const HK_DIR = ['with', 'against'];
export const HK_PROF = ['circle', 'egg', 'mouth', 'rect'];
export const HK_SYS = ['SW', 'RW', 'MW'];

export default function HkFields({ t, obj, endName, patch }) {
  const hk = obj.hk || {};
  const [open, setOpen] = useState(!obj.hk);
  const set = (k) => (e) => patch({ hk: { ...hk, [k]: e.target.type === 'checkbox' ? e.target.checked : e.target.value } });
  const inp = (k, mode = 'text', ph = '') => <input data-testid={`hk-${k}`} inputMode={mode} value={hk[k] ?? ''} placeholder={ph} onChange={set(k)} />;
  const sel = (k, opts, pre) => <select data-testid={`hk-${k}`} value={hk[k] || ''} onChange={set(k)}><option value="">–</option>{opts.map((o) => <option key={o} value={o}>{t[pre + o] || o}</option>)}</select>;
  return (
    <details className="hk-box" data-testid="hk-box" open={open} onToggle={(e) => setOpen(e.currentTarget.open)}>
      <summary><b>{t.hkTitle}</b> <small className="muted">{endName(obj.points[0])} → {endName(obj.points[obj.points.length - 1])}</small></summary>
      <div className="hk-grid">
        <label>{t.hkStreet}{inp('street')}</label>
        <label>{t.hkNo}{inp('no', 'text', 'S1001–S1002')}</label>
        <label>{t.hkDir}{sel('dir', HK_DIR, 'hkDir_')}</label>
        <label>{t.hkSys}{sel('sys', HK_SYS, 'hkSys_')}</label>
        <label>{t.hkProf}{sel('prof', HK_PROF, 'hkProf_')}</label>
        <label>{t.hkH}{inp('h', 'numeric')}</label>
        <label>{t.hkW}{inp('w', 'numeric')}</label>
        <label>{t.hkMat}{inp('mat', 'text', 'PP, STZ, B …')}</label>
        <label>{t.hkYear}{inp('year', 'numeric')}</label>
        <label>{t.hkLenInsp}{inp('lenI', 'decimal')}</label>
        <label>{t.hkWeather}{inp('weather')}</label>
        <label>{t.hkOperator}{inp('op')}</label>
        <label className="chk-row"><input type="checkbox" data-testid="hk-clean" checked={!!hk.clean} onChange={set('clean')} /> {t.hkClean}</label>
      </div>
    </details>
  );
}

export const hkLine = (p, t) => {
  const h = p.hk;
  if (!h) return '';
  return [h.no && `${t.hkNo} ${h.no}`, h.street, h.dir && t['hkDir_' + h.dir], h.sys && t['hkSys_' + h.sys], h.prof && `${t['hkProf_' + h.prof]}${h.h ? ` ${h.h}${h.w ? '/' + h.w : ''} mm` : ''}`,
    h.mat, h.year && `${t.hkYear} ${h.year}`, h.lenI && `${t.hkLenInsp} ${h.lenI} m`, h.weather, h.clean && t.hkClean, h.op && `${t.hkOperator}: ${h.op}`].filter(Boolean).join(' · ');
};
